export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  SERVICES: '/services',
  SERVICES_CONSULTATIONS: '/services/consultations',
  SERVICES_SCANS: '/services/scans',
  SERVICES_INTEGRATED_HEALTH: '/services/integrated-health-consultation-bio-scan',
  SERVICES_COURSES: '/services/courses',
  WORK_WITH_ME: '/work-with-me',
  WOMENS_HEALTH: '/womens-health',
  CHRONIC_HEALTH: '/chronic-health',
  BOOKS: '/books',
  TRAINING: '/training',
  PRODUCTS: '/products',
  BLOG: '/blog',
  NOT_FOUND: '*',
} as const

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES]
